import { IPOW3Fetchers } from "../../network/fetchers/POW3Fetchers";
import { Environment } from "../../network/domain/Environment";
import { makeObservable, observable } from "mobx";

export interface ICurrentEnvironmentStore {
    currentEnvironment: Environment | null;
    countryIsMedicalDevice: boolean;
    getCurrentEnvironment(): Promise<void>;
}

export class CurrentEnvironmentStore implements ICurrentEnvironmentStore {
    
    constructor(
        private readonly pow3Fetchers: IPOW3Fetchers
    ) {
        makeObservable(this);
    }
    
    @observable
    public countryIsMedicalDevice: boolean = true; //default true

    @observable
    public currentEnvironment: Environment | null = null;
    
    public async getCurrentEnvironment(): Promise<void> {
        const result = await this.pow3Fetchers.getCurrentEnvironment();
        if (result.allOk) {
            this.currentEnvironment = result.environment;
            this.countryIsMedicalDevice = result.countryIsMedicalDevice;
        }
    }
}
